import React from 'react';
import { cx } from '@emotion/css';
import type { IconProps } from '../Icon';
import { Black } from '../constants/colors';
import { Sizes } from '../constants/sizes';

const SearchIcon = (props: IconProps): JSX.Element => {
  const {
    className,
    'data-testid': dataTestId,
    fill = Black.V100,
    size = Sizes.Medium,
    onClick,
    onMouseEnter,
    onMouseLeave,
  } = props;
  const classNames = cx('sds-icon', 'sds-icon-search', className);
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
      className={classNames}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-testid={dataTestId}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.66667 2.75C4.50355 2.75 2.75 4.50355 2.75 6.66667C2.75 8.82978 4.50355 10.5833 6.66667 10.5833C8.82978 10.5833 10.5833 8.82978 10.5833 6.66667C10.5833 4.50355 8.82978 2.75 6.66667 2.75ZM1.25 6.66667C1.25 3.67512 3.67512 1.25 6.66667 1.25C9.65821 1.25 12.0833 3.67512 12.0833 6.66667C12.0833 9.65821 9.65821 12.0833 6.66667 12.0833C3.67512 12.0833 1.25 9.65821 1.25 6.66667Z'
      />
      <path d='M10.4685 9.52649L9.52565 10.4693L12.8585 13.8021L13.8013 12.8593L10.4685 9.52649Z' />
    </svg>
  );
};

export default SearchIcon;
